import { render, staticRenderFns } from "./EditGeneralMemberView.vue?vue&type=template&id=65f97486&scoped=true"
import script from "./EditGeneralMemberView.vue?vue&type=script&lang=js"
export * from "./EditGeneralMemberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f97486",
  null
  
)

export default component.exports